import { Versions, ABPlayersSources } from '../types';

Versions;
export const sourcesMock: ABPlayersSources[] = [
    {
        [Versions.original]:
            'https://landr-dev.cdn.prismic.io/landr-dev%2F0c8570eb-659d-4583-b06c-f72359ca7354_intro-original.mp3',
        [Versions.mastered]:
            'https://landr-dev.cdn.prismic.io/landr-dev%2F62710c38-5238-4719-9ace-722e5ba383ec_intro-mastered.mp3',
    },
    {
        [Versions.original]:
            'https://landr-dev.cdn.prismic.io/landr-dev%2Fdbf1cec7-60d9-4c93-81b7-594fba13b30f_valdivia-original.mp3',
        [Versions.mastered]:
            'https://landr-dev.cdn.prismic.io/landr-dev%2F8eae1311-877c-4584-8438-ac0a477747ce_valdivia-mastered.mp3',
    },
    {
        [Versions.original]:
            'https://landr-dev.cdn.prismic.io/landr-dev%2Fecadd234-1c2e-47d5-8365-0bc2609e47b5_quick_original.mp3',
        [Versions.mastered]:
            'https://landr-dev.cdn.prismic.io/landr-dev%2Fad317dd3-6d5d-4e1b-a42b-9af46cf852b9_quick_mastered.mp3',
    },
];
